import "./App.css";
import { BrowserRouter as Router, Route, Routes  } from "react-router-dom";
import Login from "./Login";
import Register from "./Register";
import Reset from "./Reset";
import Dashboard from "./Dashboard";
//import FirebaseDB from "./FirebaseDB";

import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

//import NavBar2 from './components/content/Navbar2';

import SideBar from './components/sidebar/SideBar';
import LoginCom from './components/content/LoginCom';
import CCTVCom from './components/content/CCTVCom';
import Content from './components/content/Content';
import About from './components/content/About';

import PrivacyCom from './components/content/PrivacyCom';
import ContactCom from './components/content/ContactCom';
import AdComponent from './components/content/ContactCom';

// import { Redirect } from 'react-router'
//import { Redirect } from 'react-router';

import { Helmet } from 'react-helmet-async';


class App extends Component {

  constructor(props) {
    super(props);

    // Moblie first
    this.state = {
      isOpen: false,
      isMobile: true,
    }

    this.previousWidth = -1;
  }

  updateWidth() {
    const width = window.innerWidth
    const widthLimit = 576;
    const isMobile = (width <= widthLimit);
    const wasMobile = (this.previousWidth <= widthLimit);

    if (isMobile !== wasMobile) {
      this.setState({
        isOpen: !isMobile
      })
    }

    this.previousWidth = width;
  }

  
  /**
   * Add event listener
   */
  componentDidMount() {
    this.updateWidth();
    window.addEventListener("resize", this.updateWidth.bind(this));
  }

  /**
   * Remove event listener
   */
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWidth.bind(this));
  }

  toggle = () => {
    this.setState({ isOpen: !this.state.isOpen });
  }


  render(){

    return (
      <div className="App wrapper">


        <SideBar toggle={this.toggle} isOpen={this.state.isOpen} />
        
        <Content toggle={this.toggle} isOpen={this.state.isOpen} >
          
          </Content>
        

      

          

      </div >
    );

  
  }
  
}

export default App;
